// extracted by mini-css-extract-plugin
module.exports = {"chip":"common_chip__1Hhkk","closebtn":"common_closebtn__2fPfU"};